export default "__VITE_ASSET__DSrBDWeB__"